import { TFunction } from 'react-i18next';

export const statusToString = (
  status: string,
  t: TFunction<'translation', undefined>,
) => {
  switch (status) {
    case 'NEW':
      return t('laNew');
    case 'IN_PROGRESS':
      return t('inProgress');
    case 'SKIPPED':
      return t('taskSkipped');
    case 'COMPLETED':
      return t('completed');
    default:
      return '';
  }
};
